import React from 'react';
import Icon from 'components/Icon';
import { VisibilityContext } from 'react-horizontal-scrolling-menu';

export function LeftArrow() {
  const { isFirstItemVisible, scrollPrev } = React.useContext(VisibilityContext);
  return isFirstItemVisible ? null : (
    <div
      className="carousel-button button-previous"
      onClick={() => scrollPrev()}
      role="button"
      aria-label="previous"
    >
      <Icon name="chevron-left" size="large" />
    </div>
  );
}
